var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-form', {
    ref: "form",
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.buscarCalendario.apply(null, arguments);
      }
    }
  }, [_c('v-row', {
    staticClass: "d-flex justify-center mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome do Calendário",
      "outlined": "",
      "dense": "",
      "hide-details": ""
    },
    on: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.buscarCalendario.apply(null, arguments);
      }
    },
    model: {
      value: _vm.form.filters.nomeCalendario,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "nomeCalendario", $$v);
      },
      expression: "form.filters.nomeCalendario"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "only-number",
      rawName: "v-only-number"
    }],
    attrs: {
      "label": "Ano",
      "outlined": "",
      "dense": "",
      "hide-details": ""
    },
    on: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.buscarCalendario.apply(null, arguments);
      }
    },
    model: {
      value: _vm.form.filters.ano,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "ano", $$v);
      },
      expression: "form.filters.ano"
    }
  })], 1), _c('sca-select-ativo', {
    attrs: {
      "cols": 3,
      "config": {
        labelAtivo: 'Ativo',
        labelInativo: 'Inativo',
        label: 'Situação'
      }
    },
    on: {
      "enter": _vm.buscarCalendario
    },
    model: {
      value: _vm.form.filters.ativo,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "ativo", $$v);
      },
      expression: "form.filters.ativo"
    }
  })], 1), _c('div', {
    staticClass: "text-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('sca-submit-button'), _c('sca-tooltip', {
    attrs: {
      "text": 'Limpar',
      "icon": 'mdi-eraser'
    },
    on: {
      "click": function ($event) {
        return _vm.resetForm();
      }
    }
  }), _c('sca-tooltip', {
    attrs: {
      "text": 'Incluir',
      "icon": 'mdi-plus'
    },
    on: {
      "click": function ($event) {
        return _vm.openDialogManterCalendario();
      }
    }
  })], 1)], 1)], 1), _c('v-data-table', {
    staticClass: "mt-5",
    attrs: {
      "headers": _vm.table.headers,
      "items": _vm.table.itens,
      "items-per-page": 10,
      "footer-props": _vm.$footerProps,
      "no-data-text": "Não há registros a serem exibidos."
    },
    scopedSlots: _vm._u([{
      key: `item.situacao`,
      fn: function (_ref) {
        var item = _ref.item;
        return [_c('sca-label-ativo', {
          attrs: {
            "ativo": item.situacao,
            "config": {
              labelAtivo: 'Ativo',
              labelInativo: 'Inativo'
            }
          }
        })];
      }
    }, {
      key: `item.acoes`,
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_c('sca-tooltip', {
          attrs: {
            "text": 'Gerenciar Calendário',
            "icon": 'mdi-calendar',
            "small": true
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogGerenciarCalendario(item);
            }
          }
        }), _c('sca-tooltip', {
          attrs: {
            "text": 'Visualizar',
            "icon": 'mdi-eye-outline',
            "small": true
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogVisualizarCalendario(item);
            }
          }
        }), _c('sca-tooltip', {
          attrs: {
            "text": 'Editar',
            "icon": 'mdi-pencil',
            "small": true
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogManterCalendario(item);
            }
          }
        }), _c('sca-tooltip', {
          attrs: {
            "text": `${item.situacao ? 'Inativar' : 'Ativar'}`,
            "icon": `${item.situacao ? 'mdi-toggle-switch-off' : 'mdi-toggle-switch'}`,
            "small": true
          },
          on: {
            "click": function ($event) {
              return _vm.inativarAtivarCalendario(item);
            }
          }
        })];
      }
    }], null, true)
  })], 1), _c('CadastrarEditarCalendarioDialog', {
    attrs: {
      "visible": _vm.dialogManterCalendario.visible,
      "content": _vm.dialogManterCalendario.content,
      "edit": _vm.dialogManterCalendario.edit
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogManterCalendario.close();
      },
      "onSave": function ($event) {
        return _vm.buscarCalendario();
      }
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }